<template>
  <div>
    <ckeditor :editor="editor" v-model="editContent" :config="editorConfig"></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor"
import UploadAdapter from "@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter"
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation"
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat"
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote"
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold"
import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder"
import CKFinderUploadAdapter from "@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter"
import Heading from "@ckeditor/ckeditor5-heading/src/heading"
import Image from "@ckeditor/ckeditor5-image/src/image"
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar"
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption"
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle"
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize"
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage"
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload"
import Indent from "@ckeditor/ckeditor5-indent/src/indent"
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic"
import Link from "@ckeditor/ckeditor5-link/src/link"
import List from "@ckeditor/ckeditor5-list/src/list"
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed"
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice"
import Table from "@ckeditor/ckeditor5-table/src/table"
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar"
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment"
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave"
import Code from "@ckeditor/ckeditor5-basic-styles/src/code"
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock"
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor"
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor"
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize"
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight"
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily"
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline"
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock"
import Mention from "@ckeditor/ckeditor5-mention/src/mention"
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak"
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat"
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters"
import SpecialCharactersCurrency from "@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency"
import SpecialCharactersArrows from "@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows"
import SpecialCharactersEssentials from "@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials"
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin"
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical"
import SpecialCharactersText from "@ckeditor/ckeditor5-special-characters/src/specialcharacterstext"
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough"
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript"
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript"
import TodoList from "@ckeditor/ckeditor5-list/src/todolist"
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline"
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount"
import MediaEmbedToolbar from "@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar"
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials"
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph"
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview"
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn"
export default {
  name: "CkeditorCmp",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    cmsUrl: {
      type: String,
      default: "http://zhibiao.haomeide.cn/",
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          UploadAdapter,
          TextTransformation,
          Autoformat,
          BlockQuote,
          Bold,
          CKFinder,
          CKFinderUploadAdapter,
          Heading,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          ImageResize,
          LinkImage,
          ImageUpload,
          Indent,
          Italic,
          Link,
          List,
          MediaEmbed,
          PasteFromOffice,
          Table,
          TableToolbar,
          Alignment,
          Autosave,
          Code,
          CodeBlock,
          FontBackgroundColor,
          FontColor,
          FontSize,
          Highlight,
          FontFamily,
          HorizontalLine,
          IndentBlock,
          Mention,
          PageBreak,
          RemoveFormat,
          SpecialCharacters,
          SpecialCharactersCurrency,
          SpecialCharactersArrows,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          Strikethrough,
          Subscript,
          Superscript,
          TodoList,
          Underline,
          WordCount,
          MediaEmbedToolbar,
          Essentials,
          Paragraph,
          ButtonView,
        ],
        image: {
          toolbar: [
            "imageStyle:inline",
            "imageStyle:wrapText",
            "imageStyle:breakText",
            "|",
            "toggleImageCaption",
            "imageTextAlternative",
          ],
        },
        toolbar: {
          items: [
            "code",
            "heading",
            "|",
            "bold",
            "italic",
            "strikethrough",
            "underline",
            "horizontalLine",
            "alignment",
            "|",
            "link",
            "indent",
            "outdent",
            "blockQuote",
            "imageUpload",
            "numberedList",
            "bulletedList",
            "mediaEmbed",
            "insertTable",
            "codeBlock",
            "fontBackgroundColor",
            "fontColor",
            "fontSize",
            "highlight",
            "fontFamily",
            "pageBreak",
            "removeFormat",
            "specialCharacters",
            "subscript",
            "superscript",
            "todoList",
            "undo",
            "redo",
            "imageTextAlternative",
            "imageStyle:block",
            "imageStyle:side",
          ],
          shouldNotGroupWhenFull: true,
        },
        indentBlock: {
          classes: [
            'custom-block-indent-1',
            'custom-block-indent-2',
            'custom-block-indent-3',
            'custom-block-indent-4',
            'custom-block-indent-5',
            'custom-block-indent-6',
            'custom-block-indent-7',
            'custom-block-indent-8',
            'custom-block-indent-9',
            'custom-block-indent-10',
          ]
        },
        table: {
          contentToolbar: ["tableRow", "tableColumn", "mergeTableCells"],
        },
        mediaEmbed: {
          providers: [
            {
              name: "myprovider",
              url: [/^lizzy.*\.com.*\/media\/(\w+)/, /^www\.lizzy.*/, /(http|https):\/\/([\w.]+\/?)\S*/],
              html: (match) => {
                //获取媒体url
                const input = match["input"]
                return (
                  '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
                  `<iframe src="${input}" ` +
                  'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                  'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                  "</iframe>" +
                  "</div>"
                )
              },
            },
          ],
        },
        language: "zh-cn", //中文包
        ckfinder: {
          uploadUrl: this.cmsUrl + "api/content/upload",
        },
      },
      editContent: "",
    }
  },
  watch: {
    isShow() {
      this.editContent = ""
    },
    content() {
      this.editContent = this.content
    },
  },
  mounted() {
    this.editContent = this.content
  },
  methods: {
    getContent() {
      return this.editContent
    }
  }
}
</script>

<style>
.custom-block-indent-1 {
  text-indent: 2em;
}
.custom-block-indent-2 {
  text-indent: 4em;
}
.custom-block-indent-3 {
  text-indent: 6em;
}
.custom-block-indent-4 {
  text-indent: 8em;
}
.custom-block-indent-5 {
  text-indent: 10em;
}
.custom-block-indent-6 {
  text-indent: 12em;
}
.custom-block-indent-7 {
  text-indent: 14em;
}
.custom-block-indent-8 {
  text-indent: 16em;
}
.custom-block-indent-9 {
  text-indent: 18em;
}
.custom-block-indent-10 {
  text-indent: 20em;
}
</style>
